
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/shipping-and-payment",
      function () {
        return require("private-next-pages/[locale]/help/shipping-and-payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/shipping-and-payment"])
      });
    }
  